import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Canvases } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { type Canvas } from '~/swr-hooks/canvases/types';
import { CANVASES_LIST } from '~/swr-hooks/canvases/useListCanvases';

export type UsePrivateCanvasesDuplicateCanvasMutationParams = NonNullable<Parameters<typeof Canvases.duplicate>[0]>;

export const usePrivateCanvasesDuplicateCanvasMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UsePrivateCanvasesDuplicateCanvasMutationParams) =>
      callAirApi<Canvas>(() => Canvases.duplicate(params)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [CANVASES_LIST] });
    },
  });
};
